import { render, staticRenderFns } from "./ConvoReferences.vue?vue&type=template&id=1aa75237&"
import script from "./ConvoReferences.vue?vue&type=script&lang=js&"
export * from "./ConvoReferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports